// extracted by mini-css-extract-plugin
export default {"container":"Chip_container__2BDql","demoSection":"Chip_demoSection__fPqKz","demoGrid":"Chip_demoGrid__SescD","demoWrapper":"Chip_demoWrapper__T9ouz"};